import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Grid, MenuItem , TextField, Select, InputLabel, FormControl, Button, CircularProgress } from '@material-ui/core';
import { editUser } from '../../../store/admin';
import checkPermissions from "../../../utils/checkPermissions";
import StatusDisplay from "../StatusDisplay";
import styles from "../styles";
import _ from "lodash"

const EditUser = (props) => {
  // NOTE // current users airline, current users user_type, selectedUser, and modal close func
  const { userAirline, userType, selectedUser, handleClose, status } = props
  const classes = styles();
  const dispatch = useDispatch();
  const [editedUser, setEditedUser] = React.useState(_.cloneDeep(selectedUser));

  const handleChangeSelect = (event) => {
    setEditedUser({ ...editedUser, [event.target.name]: event.target.value });
  };

  const formatUser = () => {
    let userCopy = _.cloneDeep(editedUser)
    // NOTE // add original email for id
    userCopy.originalEmail = selectedUser.email
    // NOTE // make new email lowercase
    userCopy.email = userCopy.email.toLowerCase()
    // NOTE // remove airline_id (don't want it changed)
    delete userCopy.airline_id
    // NOTE // remove password property if it's blank
    if (!userCopy.password) {
      delete userCopy.password
    }
    return userCopy
  }

  const submitEdit = () => {
    dispatch(editUser(formatUser()));
  }

  const { user_type, first_name, last_name, email, password } = editedUser;

  return (
    <Grid container className={classes.paper} >
      <Grid item xs={12} className={classes.spacing}>
        <TextField label="Email" variant="outlined" fullWidth value={email} onChange={handleChangeSelect} name="email" />
      </Grid>
      <Grid item xs={12} className={classes.spacing}>
        <TextField label="First name" variant="outlined" fullWidth value={first_name} onChange={handleChangeSelect} name="first_name" />
      </Grid>
      <Grid item xs={12} className={classes.spacing}>
        <TextField label="Last name" variant="outlined" fullWidth value={last_name} onChange={handleChangeSelect} name="last_name" />
      </Grid>
      <Grid item xs={12} className={classes.spacing}>
        <TextField label="Password (leave blank to keep old password)" type="password" autoComplete="current-password" variant="outlined" fullWidth value={password} onChange={handleChangeSelect} name="password" />
      </Grid>
      <Grid item xs={12} className={classes.spacing}>
        <FormControl className={classes.formControl} fullWidth>
          <InputLabel id="select-role-label">Select role</InputLabel>
          <Select labelId="select-role-label" value={user_type} name="user_type" onChange={handleChangeSelect} label="Select role" variant="outlined">
            <MenuItem style={{ display: checkPermissions(userType, userAirline, 'addNonAdminUser', true) }} value="pilot">Pilot/Concierge/Tier 1 Reservations</MenuItem>
            <MenuItem style={{ display: checkPermissions(userType, userAirline, 'addNonAdminUser', true) }} value="reservations">Reservations</MenuItem>
            <MenuItem style={{ display: checkPermissions(userType, userAirline, 'addNonAdminUser', true) }} value="scheduling">Scheduling/Dispatch</MenuItem>
            <MenuItem style={{ display: checkPermissions(userType, userAirline, 'addNonAdminUser', true) }} value="handler">Handler</MenuItem>
            <MenuItem style={{ display: checkPermissions(userType, userAirline, 'addNonAdminUser', true) }} value="read_only">Read only</MenuItem>
            <MenuItem value="admin">Admin</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid container item xs={12} style={{marginTop: '8px'}}>
        <Grid item xs={3}></Grid>
        <Grid container justifyContent="center" item xs={3}>
          <Button variant="contained" color="primary" onClick={submitEdit} disabled={status}>
            Submit
          </Button>
        </Grid>
        <Grid container justifyContent="center" item xs={3}>
          <Button variant="contained" style={{ backgroundColor: '#d13939', marginLeft: '8px' }} onClick={() => {handleClose(false)}}>
            Close
          </Button>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" item xs={12}>
        { !status ? <div></div> : <StatusDisplay status={status} /> }
      </Grid>
    </Grid>
  );
}

export default EditUser